import { BeneficiaryCountry } from '@seapoint/server/enums';

export const isSupportedBeneficiaryCountry = (country?: string): country is BeneficiaryCountry => {
  if (!country) {
    return false;
  }

  return Object.values(BeneficiaryCountry).includes(country as BeneficiaryCountry);
};
